/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import React, { useRef, useState, useEffect, useContext, useCallback } from 'react';
import Keyboard from 'react-simple-keyboard';
import { useFocusTrap } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { showNotification } from '@mantine/notifications';
import dayjs from 'dayjs';
import 'react-simple-keyboard/build/css/index.css';
import {
  Box,
  Center,
  Stack,
  Button,
  Title,
  ActionIcon,
  Modal,
  Textarea,
  Text,
  Group,
  Input,
  Select,
  Divider,
  List,
  Space,
  Grid,
  Table,
  ScrollArea,
  SimpleGrid,
  Image,
  TextInput,
  Card,
  Container,
  Paper,
  Loader,
} from '@mantine/core';
import { IconX } from '@tabler/icons';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import carWash from '../../image/car-wash.svg';
import trolley from '../../image/trolley.svg';
import backButton from '../../image/backArrow.png';
import home from '../../image/home.svg';
import QR from '../../image/qr.png';
import AlertImg from '../../image/alert.svg';
import CarArrow from '../../image/car-arrow.png';
import CarArrowReverse from '../../image/carArrow-reverse.png';
import PrimaryButton from '../../components/GroupButton';
import AppContext from '../../components/Context/index';
import { sendRequest, sendRequestWithToken } from '../../services/services';
import PaymentStatus from '../PosPayment/PaymentStatus';
import TicketSummary from '../../components/TicketSummary/TicketSummary';
import TimerEvent from '../../components/TimerEvent/TimerEvent';

const UserDetails = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t, i18n } = useTranslation();
  const searchParams = new URLSearchParams(search);
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;
  const passIdData = searchParams.get('passId');
  const [mounted, setMounted] = useState(false);
  const [location, setLocation] = useState('');
  const focusTrapRef = useFocusTrap();
  const [ticketNumber, setTicketNumber] = useState();
  const [cardPay, setCardPay] = useState(false);
  const [errorPos, setErrorPos] = useState(false);

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));

  const [ticketData, setTicketData] = useState();
  const [input, setInput] = useState('');
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const [buttonText, setButtonText] = useState('Arabic');

  // console.log('id', ticketData?.result?.passId);
  // const searchTicket = useCallback(() => {
  //   sendRequest(`parking/reservations-by-pass-id/${input}`, 'get').then((res) => {
  //     setTicketData(res?.data || []);
  //   });

  //   if (ticketData === 'empty') {
  //     showNotification({
  //       title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
  //       icon: <IconX />,
  //     });
  //   }
  // });

  const searchTicket = useCallback(() => {
    sendRequest(`parking/site-id-by-pass-id/${input}`, 'get').then((data) => {
      console.log('res', data);
      if (data?.data?.site_id === siteDetails?.siteId) {
        sendRequest(`parking/reservations-by-pass-id/${input}`, 'get').then((res) => {
          console.log('res', res);
          if (res?.code === 20) {
            setTicketData(res?.data || []);
          } else if (res?.code === 21) {
            showNotification({
              title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
              icon: <IconX size={16} />,
            });
          }
        });
      } else if (data?.data?.site_id !== siteDetails?.siteId) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.site.id')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });
  });

  const onChange = (inputValue) => {
    setInput(inputValue);
    console.log('Input changed', inputValue);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (buttonText === 'Arabic') {
      setButtonText('English');
    } else if (buttonText === 'English') {
      setButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    console.log('Button pressed', button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}') searchTicket();
  };

  const onChangeInput = (event) => {
    const data = event.target.value;
    setInput(data);
    keyboard.current.setInput(data);
  };

  useEffect((button) => {
    if (button === '{enter}') {
      searchTicket();
    }
  }, []);

  const onPayment = async () => {
    fetch('https://sp.api.v2.hyperthings.in/api/v1/payments/checkout', {
      method: 'POST',
      headers: {
        android_id: 'test',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        reservation_id: parseInt(ticketData?.result?.id, 10),
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response?.code === 20) {
          navigate({
            pathname: '/payment',
            search: createSearchParams({
              passId: parseInt(ticketData?.result?.id, 10),
              checkoutId: response?.data?.id,
            }).toString(),
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const posPayment = () => {
    navigate({
      pathname: '/insertcard',
      search: createSearchParams({
        passId: input,
      }).toString(),
    });
  };

  const detailsPage = () => {
    navigate({
      pathname: '/services',
      search: createSearchParams({
        numberplate: ticketData?.result?.vehicles?.number_plate,
        tax: ticketData?.result?.invoices?.tax,
        passId: input,
      }).toString(),
    });
  };

  const now = dayjs();

  const date1 = dayjs(ticketData?.result?.start_time);
  const date2 = dayjs(!ticketData?.result?.end_time ? now : ticketData?.result?.end_time);
  // const diff = date2.diff(date1, 'day', true);
  // console.log('obtained', diff);
  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  // console.log('hours', TotalSeconds / 3600);

  // const [language, setLanguage] = useState('ar');
  // i18n.changeLanguage(language);

  // const changeLanguageHandler = () => {
  //   const languageValue = language;
  //   i18n.changeLanguage(languageValue);
  //   if (buttonText === 'Arabic') {
  //     setButtonText('English');
  //   } else if (buttonText === 'English') {
  //     setButtonText('Arabic');
  //   }
  //   if (language === 'ar') {
  //     setLanguage('en');
  //   } else if (language === 'en') {
  //     setLanguage('ar');
  //   }
  // };

  const startDate = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const startTime = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(10);

  const endDate = dayjs(!ticketData?.result?.end_time ? now : ticketData?.result?.end_time)
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const endTime = dayjs(!ticketData?.result?.end_time ? now : ticketData?.result?.end_time)
    .format('DD-MM-YYYY HH:mm')
    .slice(10);

  const [response, setResponse] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [cashData, setCashData] = useState();

  const cardPayment = () => {
    if (ticketData?.result?.invoices?.invoice_status?.name === 'paid') {
      setCardPay(true);
    }

    const wsurl = `ws://localhost:5000/messages`;

    // Init Websocket Client
    const client = new W3CWebSocket(wsurl);
    client.onerror = () => {
      console.log('Connection Error');
      if (ticketData?.result?.invoices?.invoice_status?.name === 'paid') {
        setCardPay(true);
      } else {
        setErrorPos(true);
      }
    };

    client.onopen = () => {
      console.log('WebSocket Client Connected');

      function connectPort() {
        if (client.readyState === client.OPEN) {
          const comName = 'COM8';
          const sendData = JSON.stringify({
            Event: 'CONNECTION',
            Operation: 'CONNECT',
            connectionMode: 'COM',
            comName,
            braudRate: '38400',
            dataBits: '8',
            parity: 'none',
          });

          client.send(sendData);
        }
      }

      connectPort();

      function sendAmount() {
        if (client.readyState === client.OPEN) {
          const amount = ticketData?.result?.invoices?.payable_amount;
          const sendAmountData = JSON.stringify({
            Event: 'TRANSACTION',
            Operation: 'PURCHASE',
            Amount: amount,
            PrintSettings: '1',
            AppId: '11',
            ECRNumber: '1234567890123456',
          });
          client.send(sendAmountData);
        }
      }
      sendAmount();
    };

    client.onclose = () => {
      console.log('echo-protocol Client Closed');
    };

    client.onmessage = (message) => {
      if (typeof message.data === 'string') {
        // console.log('Received', message.data);
        setResponse(JSON.parse(message?.data));
      }
    };
  };
  useEffect(() => {
    if (response?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (response?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (response?.EventName === 'TERMINAL_RESPONSE') {
      setPaymentStatus(JSON.parse(response?.JsonResult));
    }
  }, [response, ticketData?.result?.invoices?.invoice_status?.name]);

  console.log('payment-status', paymentStatus);

  useEffect(() => {
    if (response?.EventName === 'TERMINAL_RESPONSE') {
      const body = {
        reservation_id: parseInt(ticketData?.result?.id, 10),
        transaction_id: paymentStatus?.RetrievalReferenceNumber,
      };
      sendRequestWithToken(`cashier/card-payment`, 'post', body)
        .then(({ data, code }) => {
          if (code === 20) {
            setCashData(data);
            searchTicket();
            setCardPay(true);
            console.log('payment-status', paymentStatus);
            console.log('push-resID&transactionId to backend', body, data);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err?.response?.data?.code) {
            console.log('err', err?.response?.data?.code);
          }
        });
    }
  }, [
    paymentStatus,
    paymentStatus?.RetrievalReferenceNumber,
    response?.EventName,
    searchTicket,
    ticketData?.result?.id,
  ]);

  return (
    <Box>
      {ticketData?.result?.id ? <TimerEvent /> : null}
      <Center className="no-printme">
        {!ticketData?.result?.id ? (
          <Title style={{ color: '#F9D923' }} order={1}>
            {/* Enter Ticket Number */}
            {t('enter.ticket.number')}
          </Title>
        ) : (
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('enter.ticket.summary')}
          </Title>
        )}
      </Center>
      {!ticketData?.result?.id ? (
        <>
          <Space h="xs" />
          <Space h="xs" />
        </>
      ) : null}
      <Center>
        <Stack className="no-printme">
          <Center>
            {/* <Input placeholder="Ticket Number" width="100%" onChange={searchTicket} p="xl" /> */}
            <div className="App">
              {!ticketData?.result?.id ? (
                <Input
                  placeholder={t('enter.ticket.number.placeholder')}
                  sx={{ width: '100%' }}
                  value={input}
                  onChange={onChangeInput}
                  size="xl"
                  disabled={ticketData?.result?.id}
                />
              ) : null}
            </div>
          </Center>
          {/* {!ticketData?.result?.id && ticketNumber ? (
            <Center>
              <Title order={3}>{t('enter.invalid.ticket.number')}</Title>
            </Center>
          ) : null} */}
          {ticketData?.result?.id ? (
            // <Box className="no-printme">
            //   <Paper shadow="lg" withBorder p="xl">
            //     <Stack>
            //       <Group position="apart">
            //         <Text size="sm" weight={500} color="#817E7E">
            //           {t('ticket.welcome')} {t('ticket.guest')}
            //         </Text>

            //         {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
            //           <Text size="xl" weight={700} color="green">
            //             {t('status.paid')}
            //           </Text>
            //         ) : null}

            //         <Text size="sm" weight={500} color="#817E7E">
            //           {t('ticket.plate.number')} : {ticketData?.result?.vehicles?.number_plate}
            //         </Text>
            //       </Group>

            //       <Group position="apart" style={{ marginBottom: '-20px' }}>
            //         <Group>
            //           <Stack>
            //             <Center>
            //               <Title size="sm" order={2}>
            //                 {t('ticket.entry.text')}
            //               </Title>
            //             </Center>
            //             <Center style={{ marginBottom: '-18px' }}>
            //               <Text size="sm" weight={500}>
            //                 {startDate}
            //               </Text>
            //             </Center>
            //             <Center>
            //               <Text size="sm" weight={500}>
            //                 {startTime}
            //               </Text>
            //             </Center>
            //           </Stack>
            //         </Group>
            //         {appState?.language === 'ar' ? (
            //           <Image src={CarArrowReverse} />
            //         ) : (
            //           <Image src={CarArrow} />
            //         )}
            //         <Group>
            //           <Stack>
            //             <Center>
            //               <Title size="sm" order={2}>
            //                 {t('ticket.exit.text')}
            //               </Title>
            //             </Center>
            //             <Center style={{ marginBottom: '-18px' }}>
            //               <Text size="sm" weight={500}>
            //                 {endDate}
            //               </Text>
            //             </Center>
            //             <Center>
            //               <Text size="sm" weight={500}>
            //                 {endTime}
            //               </Text>
            //             </Center>
            //           </Stack>
            //           <ActionIcon
            //             color="dark"
            //             size="xl"
            //             radius="xl"
            //             variant="default"
            //             sx={{
            //               borderColor: 'black',
            //               width: '80px',
            //               height: '80px',
            //               borderRadius: '50px',
            //             }}
            //           >
            //             <Text weight={900} size="lg">
            //               {hours} {t('ticket.hours.text')}
            //             </Text>
            //           </ActionIcon>
            //         </Group>
            //       </Group>
            //       <Group position="apart">
            //         <Stack>
            //           <Title size="sm" order={2}>
            //             {t('ticket.description.text')}
            //           </Title>
            //           <Text size="sm" weight={500} color="#817E7E">
            //             {hours} {t('ticket.hours.parking.text')}
            //           </Text>

            //           {ticketData?.result?.vas_orders.map((item) => (
            //             // <Text size="sm" weight={500} color="#817E7E">
            //             //   {item?.vas_types?.name}
            //             // </Text>
            //             <div>
            //               {appState?.language === 'en' ? (
            //                 <Text weight={500} color="#817E7E">
            //                   {item?.vas_types?.name}
            //                 </Text>
            //               ) : (
            //                 <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
            //                   {item?.vas_types?.name === 'Trolley' ? (
            //                     <Text weight={500} color="#817E7E">
            //                       {t('choose.service.trolly.title.text')}
            //                     </Text>
            //                   ) : item?.vas_types?.name === 'Car Wash' ? (
            //                     <Text weight={500} color="#817E7E">
            //                       {t('choose.service.carwash.title.text')}
            //                     </Text>
            //                   ) : (
            //                     <Text weight={500} color="#817E7E">
            //                       {t('choose.service.shuttle.title.text')}
            //                     </Text>
            //                   )}
            //                 </Group>
            //               )}
            //             </div>
            //           ))}
            //           {/* <Text size="sm" weight={500} color="#817E7E">
            //             {t('ticket.tax.text')}
            //           </Text> */}
            //         </Stack>

            //         <Stack spacing="xl">
            //           <Title size="sm" order={2}>
            //             {t('ticket.amount.text')}
            //           </Title>
            //           <Text size="sm" weight={500} color="#817E7E">
            //             {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
            //               ? 0
            //               : ticketData?.result?.invoices?.total_amount}{' '}
            //             {t('ticket.amount.sar.text')}
            //           </Text>

            //           {ticketData?.result?.vas_orders.map((item) => (
            //             <Text size="sm" weight={500} color="#817E7E">
            //               {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
            //                 ? 0
            //                 : item?.amount}{' '}
            //               {t('ticket.amount.sar.text')}
            //             </Text>
            //           ))}
            //           {/* <Text size="sm" weight={500} color="#817E7E">
            //             {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
            //               ? 0
            //               : ticketData?.result?.invoices?.tax}{' '}
            //             {t('ticket.amount.sar.text')}
            //           </Text> */}
            //         </Stack>
            //       </Group>
            //       <Divider size="sm" />
            //       <Group position="apart">
            //         <Stack>
            //           <Text size="sm" weight={500} color="#817E7E">
            //             {t('ticket.tax.text')}
            //           </Text>
            //           <Title size="sm" order={2}>
            //             {t('ticket.amount.total.text')}
            //           </Title>
            //         </Stack>
            //         <Stack px="xl">
            //           <Text size="sm" weight={500} color="#817E7E" style={{ marginLeft: '65px' }}>
            //             {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
            //               ? 0
            //               : ticketData?.result?.invoices?.tax}{' '}
            //             {t('ticket.amount.sar.text')}
            //           </Text>
            //           <Title size="sm" order={2} px="xs">
            //             {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
            //               ? 0
            //               : ticketData?.result?.invoices?.payable_amount}{' '}
            //             {t('ticket.amount.sar.text')}
            //           </Title>
            //         </Stack>
            //       </Group>

            //       <Group position="apart">
            //         <SimpleGrid cols={2} sx={{ width: '100%' }}>
            //           {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
            //             <Button
            //               // onClick={posPayment}
            //               onClick={cardPayment}
            //               sx={{ backgroundColor: '#01AA84', width: '100%' }}
            //               size="xl"
            //               // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
            //             >
            //               {t('payment.status.invoice.print.invoice.button.text')}
            //             </Button>
            //           ) : (
            //             <Button
            //               // onClick={posPayment}
            //               onClick={cardPayment}
            //               sx={{ backgroundColor: '#01AA84', width: '100%' }}
            //               size="xl"
            //               // disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
            //             >
            //               {t('ticket.amount.pay.button.text')}
            //             </Button>
            //           )}
            //           <Button
            //             onClick={detailsPage}
            //             sx={{ backgroundColor: '#34B3F1', width: '100%' }}
            //             size="xl"
            //           >
            //             {t('ticket.amount.other.service.button.text')}
            //           </Button>
            //         </SimpleGrid>
            //       </Group>
            //     </Stack>
            //   </Paper>
            // </Box>

            <TicketSummary passId={input} />
          ) : null}
        </Stack>
      </Center>
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />

      {!ticketData?.result?.id ? (
        <Container py="xl" style={{ width: '700px' }} className="numPad">
          <Keyboard
            // eslint-disable-next-line no-return-assign
            keyboardRef={(r) => (keyboard.current = r)}
            onChange={onChange}
            layoutName={layout}
            onKeyPress={onKeyPress}
            layout={{
              default: ['1 2 3', '4 5 6', '7 8 9', '{enter} 0 {bksp}'],
            }}
            display={{
              '{bksp}': '⌫',
              '{enter}': appState?.language === 'ar' ? 'إرسال' : 'Enter',
            }}
          />
        </Container>
      ) : null}
      <Space h="xs" />

      {/* <div
        style={{
          position: 'fixed',
          bottom: 55,
          marginLeft: 100,
          marginRight: 50,
          marginBottom: 30,
        }}
      > */}

      <PrimaryButton />
      {/* <SimpleGrid cols={4} position="apart" px="xl">
        <Button
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            left: 100,
            bottom: 55,
          }}
          onClick={changeLanguageHandler}
        >
          {buttonText === 'Arabic' ? (
            <Title order={1}>عربي</Title>
          ) : (
            <Title order={1}>English</Title>
          )}
        </Button> */}
      {/* <select className="custom-select" style={{ width: 200 }} onChange={changeLanguageHandler}>
          <option value="en">English</option> <option value="ar">Arabic</option>
        </select> */}
      {/* <div />
        <div />
        <Button
          onClick={() => navigate('/')}
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            right: 100,
            bottom: 55,
          }}
        >
          <Title order={1}>Home</Title>
        </Button>
      </SimpleGrid> */}
      {/* </div> */}
      <Modal
        opened={cardPay}
        onClose={() => setCardPay(false)}
        centered
        size="90%"
        // title={<Text p="xl">You want to end the shift</Text>}
      >
        <Center>
          {paymentStatus?.TransactionResponseEnglish === 'APPROVED' ||
          ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
            <PaymentStatus
              invoiceDataId={ticketData?.result?.invoices?.id}
              passDataId={
                ticketData?.result?.passId === undefined ? input : ticketData?.result?.passId
              }
            />
          ) : (
            <Center>
              {response?.TerminalAction === 'SWIPE_OR_INSERT' ? (
                <Stack>
                  <Title order={1}>Swipe or Insert</Title>
                  <Center>
                    <Title order={1}>Card</Title>
                  </Center>
                </Stack>
              ) : (
                <div>
                  {response?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT' ? (
                    <Stack>
                      <Title order={1}>Cancel or Timeout</Title>
                    </Stack>
                  ) : (
                    <div>
                      {response?.TerminalStatus === 'BUSY' ? (
                        <Stack>
                          <Title order={1}>Payment Processing</Title>
                          <Loader variant="dots" />
                        </Stack>
                      ) : paymentStatus?.TransactionResponseEnglish === 'DECLINED' ? (
                        <Stack>
                          <Title order={1}>Card Declined</Title>
                        </Stack>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
            </Center>
          )}
        </Center>
      </Modal>
      <Modal opened={errorPos} onClose={() => setErrorPos(false)} centered size="50%">
        <Center>
          <Image src={AlertImg} width={100} />;
        </Center>
        <Center py="xl">
          <Title order={1}>Error with Connection</Title>
        </Center>
      </Modal>
    </Box>
  );
};

export default UserDetails;
